import styled from 'styled-components';
import {
  BLACK,
  WHITE,
  SALON_CONSULTATION_HEADER_HEIGHT_PC,
} from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Title = styled.h1`
  margin-bottom: 60px;
  font-size: 20px;
  text-align: left;
  margin-left: 20px;

  .title {
    font-size: 30px;
  }
  .lead {
    font-size: 24px;
  }

  ${media.tabletP`
  margin-bottom: 80px;
  margin-left: 0;
  `};
`;

export const Container = styled.div`
  /* width: 768px; */
  margin: 0 auto;
  display: flex;
  height: 100%;

  ${media.tabletP`
  height: calc(100vh - ${SALON_CONSULTATION_HEADER_HEIGHT_PC});
  margin-top: ${SALON_CONSULTATION_HEADER_HEIGHT_PC};
  `};
`;

export const HeroImage = styled.div`
  display: none;
  width: 312px;
  height: calc(100vh - ${SALON_CONSULTATION_HEADER_HEIGHT_PC});
  background: #eee;

  ${media.tabletP`
  display: block;
  `};
`;

export const RightContents = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0 auto;
  padding-top: 90px;

  ${media.tabletP`
    margin: 0 auto;
    padding-top: 0;
    height: auto;
  `};
`;

export const RigthContentsInner = styled.div`
  margin: 0 auto;
`;

export const FormGroup = styled.div`
  width: 365px;
  margin: 0 auto;
  .ant-form-item-control {
    margin-bottom: 10px;

    ${media.tabletP`
    margin-bottom: 20px;
    `};
  }
`;

export const AInputBase = styled.div`
  .has-error .ant-input:not([disabled]):hover,
  .has-error .ant-input:focus,
  .ant-input:focus {
    border-bottom-color: #f5222d;
    box-shadow: none;
  }
  .ant-input {
    width: 100%;
    height: 40px;
    margin-bottom: 0;
    padding: 4px 0px;
    border: 0;
    border-bottom: 2px solid #666;
    font-size: 18px;
    border-radius: 0;

    ${media.tabletP`
    width: 365px;
    margin-bottom: 10px;
    `};
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  padding: 0 20px;
  margin-bottom: 24px;
  height: 68px;

  ${media.tabletP`
    padding: 0;
  `};
`;

export const AInputCover = AInputBase.extend``;
export const SubmitCover = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    width: 100%;
    height: 60px;
    margin-top: 15px;
    margin-bottom: 15px;
    border-radius: 0;
    background-color: ${BLACK};
    color: ${WHITE};
    font-size: 18px;
    opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};

    ${media.tabletP`
    width: 366px;
    margin-bottom: 30px;
    `};
  }

  .ant-btn {
    opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
  }
  .ant-btn:hover,
  .ant-btn:focus,
  .ant-btn:active,
  .ant-btn.active {
    text-decoration: none;
    background-color: ${BLACK};
  }
  .ant-btn:hover,
  .ant-btn:focus {
    color: ${WHITE};
    background-color: ${BLACK};
  }
`;
export const TextBottom = styled.div`
  font-size: 14px;
  margin-bottom: 40px;
  margin-left: 20px;
  color: #000;
  text-decoration: underline;

  ${media.tabletP`
  margin-left: 0;
  `};
`;

export const Spinner = styled.span`
  display: inline-block;
  width: 15px;
  height: 15px;

  ::after {
    content: ' ';
    display: block;
    width: 15px;
    height: 15px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: spinner 1.2s linear infinite;
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
export const ErrorMessage = styled.p`
  padding: 0 20px;
  color: red;

  ${media.tabletP`
    padding: 0;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/LoginPage/LoginPage.style.js